<script setup lang="ts">
import { ElAlert } from 'element-plus'

/** Erreurs renvoyées par l'API à l'enregistrement d'un formulaire (sous les champs). */
defineProps<{ errors: string[] }>()
</script>

<template>
  <el-alert v-if="errors.length" type="error" :closable="false" show-icon class="form-errors" role="alert">
    <template #title>
      <ul class="form-errors__list">
        <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
      </ul>
    </template>
  </el-alert>
</template>

<style scoped>
.form-errors {
  margin-top: 8px;
}

.form-errors__list {
  margin: 0;
  padding-left: 16px;
}
</style>
